import React from 'react';
// import { Search } from 'lucide-react';
import CheckPage from './CheckPage';

const PlagiarismCheck: React.FC = () => {
  return (
    <CheckPage
      title="Plagiarism Check"
      subtitle="Detect copied and mosaic content against 36,000+ academic papers"
      // icon={Search}
      accentColor="#003c6c"
      scoreLabel="Similarity"
      checkTypes={[{ key: 'plagiarism', label: 'Plagiarism' }]}
    />
  );
};

export default PlagiarismCheck;